// example:
// <div class="js-tappay-direct" data-tappay-app-id="1234567890" data-tappay-app-key="1234567890" data-tappay-sandbox="true">
//   <input class="js-card-number" type="text" placeholder="**** **** **** ****">
//   <input class="js-card-expiration" type="text" placeholder="MM/YY">
//   <input class="js-card-cvv" type="text" placeholder="***">
//   <input class="js-prime" type="hidden">
// </div>
export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-tappay-direct').forEach((el) => {
      if (typeof TPDirect === 'undefined') {
        return
      }
      // eslint-disable-next-line no-undef
      TPDirect.setupSDK(
        el.dataset.tappayAppId,
        el.dataset.tappayAppKey,
        el.dataset.tappaySandbox === 'true' ? 'sandbox' : 'production'
      )
      if (
        el.querySelector('.js-card-number') ||
        document.querySelector('.js-card-number')
      ) {
        // eslint-disable-next-line no-undef
        TPDirect.card.setup({
          fields: {
            number: {
              element:
                el.querySelector('.js-card-number') ||
                document.querySelector('.js-card-number'),
              placeholder: '**** **** **** ****',
            },
            expirationDate: {
              element:
                el.querySelector('.js-card-expiration') ||
                document.querySelector('.js-card-expiration'),
              placeholder: 'MM/YY',
            },
            ccv: {
              element:
                el.querySelector('.js-card-ccv') ||
                document.querySelector('.js-card-ccv'),
              placeholder: '***',
            },
          },
          isMaskCreditCardNumber: true,
          maskCreditCardNumberRange: {
            beginIndex: 6,
            endIndex: 11,
          },
        })
      }
      el.addEventListener('tappay:get_prime', () => {
        let prime = el.querySelector('.js-prime')
        let any_tappay_checked =
          document.querySelectorAll('input[class*="js-tappay-"]:checked')
            .length > 0
        if (prime && any_tappay_checked) {
          prime.required = true
        } else {
          return false
        }
        let creditCard = document.querySelector('input.js-tappay-credit-card')
        let linePay = document.querySelector('input.js-tappay-line-pay')
        let virtualAccount = document.querySelector(
          'input.js-tappay-virtual-atm'
        )
        if (el.dataset.linePay === 'true' || (linePay && linePay.checked)) {
          // eslint-disable-next-line no-undef
          TPDirect.linePay.getPrime(function (result) {
            if (result.status !== 0) {
              // eslint-disable-next-line no-undef
              Swal.fire(result.msg)
              prime.value = ''
              return false
            } else {
              prime.value = result.prime
              el.dispatchEvent(
                new CustomEvent('tappay:get_prime:success', {
                  detail: result,
                })
              )
            }
          })
        } else if (
          el.dataset.virtualAccount === 'true' ||
          (virtualAccount && virtualAccount.checked)
        ) {
          // eslint-disable-next-line no-undef
          TPDirect.virtualAccount.getPrime(function (error, result) {
            if (result.status !== 0) {
              // eslint-disable-next-line no-undef
              Swal.fire(result.msg)
              prime.value = ''
              return false
            } else {
              prime.value = result.prime
              el.dispatchEvent(
                new CustomEvent('tappay:get_prime:success', {
                  detail: result,
                })
              )
            }
          })
        } else if (!creditCard || creditCard.checked) {
          // eslint-disable-next-line no-undef
          let tappayStatus = TPDirect.card.getTappayFieldsStatus()
          if (tappayStatus.canGetPrime === false) {
            // eslint-disable-next-line no-undef
            Swal.fire(
              el.dataset.errorMessage || 'Please check the credit card data'
            )
            prime.value = ''
            return false
          } else {
            // eslint-disable-next-line no-undef
            TPDirect.card.getPrime(function (result) {
              if (result.status !== 0) {
                // eslint-disable-next-line no-undef
                Swal.fire(result.msg)
                prime.value = ''
                return false
              } else {
                prime.value = result.card.prime
                el.dispatchEvent(
                  new CustomEvent('tappay:get_prime:success', {
                    detail: result,
                  })
                )
              }
            })
          }
        }
      })
    })
  })
})()
